import "react-perfect-scrollbar/dist/css/styles.css";

import React from "react";
import ReactPerfectScrollbar from "react-perfect-scrollbar";

export default ({ children, ...rest }) => {
  return <ReactPerfectScrollbar {...rest}>{children}</ReactPerfectScrollbar>;
};
